import React from "react";
import PropTypes from "prop-types";

const formatTimestamp = (seconds) => {
  const total = Math.floor(seconds);
  return `${Math.floor(total / 60)}:${String(total % 60).padStart(2, "0")}`;
};

// Timestamped transcript rows for a recorded video; clicking a timestamp seeks the inline player.
// Shared by every VideoPlayer surface (messaging thread, feed card, admin review queue).
function TranscriptPanel({ segments, onSeek }) {
  return (
    <div className="transcript-panel p-2 mt-2 overflow-auto rounded-1" data-testid="transcript-panel">
      {segments.map((segment, index) => (
        <button
          type="button"
          key={`${segment.start}-${index}`} // eslint-disable-line react/no-array-index-key
          className="transcript-row d-flex align-items-center gap-2 px-1 w-100 text-start border-0"
          onClick={() => onSeek(segment.start)}
        >
          <span className="transcript-timestamp flex-shrink-0 d-flex align-items-center justify-content-center rounded-pill fw-medium">
            {formatTimestamp(segment.start)}
          </span>
          <span className="transcript-text paragraph-sm text-break py-2">{segment.text}</span>
        </button>
      ))}
    </div>
  );
}

TranscriptPanel.propTypes = {
  segments: PropTypes.arrayOf(
    PropTypes.shape({
      start: PropTypes.number.isRequired,
      end: PropTypes.number,
      text: PropTypes.string.isRequired,
    }),
  ).isRequired,
  onSeek: PropTypes.func.isRequired,
};

export default TranscriptPanel;
